module.exports = __webpack_public_path__ + "static/media/BB9.7f94dd96.png";